"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.objKeys = (val) => Object.keys(val);
exports.getOwnPropNames = (val) => Object.getOwnPropertyNames(val);
